import { FaMinus, FaPlus, FaTrash } from "react-icons/fa6";
import displayNPRCurrency from "../helpers/displayCurrency";

const AdminPOSCartItem = ({ item, updateQuantity, removeItem }) => {
  return (
    <div className="flex gap-4 p-3 bg-white rounded-xl border border-gray-100 shadow-sm">
      {/* Image */}
      <div className="w-16 h-16 bg-gray-50 rounded-lg p-2 flex-shrink-0">
        <img
          src={item.productImage[0]}
          alt={item.productName}
          className="w-full h-full object-contain mix-blend-multiply"
        />
      </div>

      {/* Details */}
      <div className="flex-1 flex flex-col justify-between">
        <div className="flex justify-between items-start">
          <h4 className="font-bold text-sm text-gray-800 line-clamp-1">
            {item.productName}
          </h4>
          <button
            onClick={() => removeItem(item._id)}
            className="text-red-400 hover:text-red-500 p-1"
            aria-label="Remove item"
            title="Remove item"
          >
            <FaTrash size={12} />
          </button>
        </div>

        <div className="flex justify-between items-end">
          <div className="text-xs font-bold text-primary">
            {displayNPRCurrency(item.sellingPrice * item.quantity)}
          </div>

          {/* Qty Controls */}
          <div className="flex items-center gap-3 bg-gray-50 rounded-lg p-1">
            <button
              onClick={() => updateQuantity(item._id, item.quantity - 1)}
              disabled={item.quantity <= 1}
              className="w-6 h-6 flex items-center justify-center bg-white rounded shadow-sm text-xs disabled:opacity-50"
              aria-label="Decrease quantity"
              title="Decrease quantity"
            >
              <FaMinus size={8} />
            </button>
            <span className="text-xs font-bold w-4 text-center">
              {item.quantity}
            </span>
            <button
              onClick={() => updateQuantity(item._id, item.quantity + 1)}
              className="w-6 h-6 flex items-center justify-center bg-white rounded shadow-sm text-xs"
              aria-label="Increase quantity"
              title="Increase quantity"
            >
              <FaPlus size={8} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPOSCartItem;
